import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120sSchL = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Schedule L (Form 1120-S) Balance Sheet | TaxZerone"
          description="Discover how to complete Schedule L (Form 1120-S) to report your S corporation’s assets, liabilities, and shareholder equity accurately for IRS compliance."
          keywords=""
          canonical="resources/business-tax/schedule-l/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule L</span>
          </span>{' '}
          (Form 1120‑S) Balance Sheet per Books, Assets, Liabilities & Equity
          Reporting
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-l/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule L (Form 1120-S) at a Glance
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Schedule L (Form 1120-S) reports an S corporation's{' '}
                    <span style={{ fontWeight: 600 }}>
                      assets, liabilities, and shareholders' equity
                    </span>{' '}
                    at the beginning and end of the tax year, based on the
                    corporation's books and records.
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        <span style={{ fontWeight: 600 }}>
                          Who Must Complete:
                        </span>{' '}
                        Most S corporations filing Form 1120-S must complete
                        Schedule L unless they qualify for the small-corporation
                        exception.
                      </span>
                    </li>
                    <li>
                      <span>
                        <span style={{ fontWeight: 600 }}>
                          What It Reports:
                        </span>{' '}
                        Schedule L includes{' '}
                        <span style={{ fontWeight: 600 }}>
                          cash, accounts receivable, inventory, fixed assets,
                          accounts payable, loans, capital stock, retained
                          earnings, and other balance-sheet accounts
                        </span>
                        .
                      </span>
                    </li>
                    <li>
                      <span>
                        <span style={{ fontWeight: 600 }}>
                          Related Schedules:
                        </span>{' '}
                        Schedule L provides book-balance information that is
                        used in conjunction with{' '}
                        <span style={{ fontWeight: 600 }}>Schedule M-1</span> to
                        reconcile book income with taxable income and{' '}
                        <span style={{ fontWeight: 600 }}>Schedule M-2</span> to
                        track changes in shareholders' equity accounts.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Schedule L, titled Balance Sheet per Books, is an
                      essential section of{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 1120‑S
                      </Link>{' '}
                      that provides a detailed snapshot of an S corporation’s
                      financial position at both the beginning and end of the
                      tax year. It reports what the corporation owns (assets),
                      owes (liabilities), and retains as shareholders’ equity.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      The IRS uses Schedule L to verify that corporate financial
                      reporting in Form 1120‑S accurately aligns with the
                      business’s actual books and records. Accurate completion
                      of Schedule L ensures compliance, financial transparency,
                      and consistency across related schedules like Schedule M‑1
                      (Reconciliation of Income) and Schedule M‑2 (Analysis of
                      Accumulated Adjustments Account).
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What Is Schedule L (Form 1120‑S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key Components of Schedule L
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must Complete Schedule L?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#relation" sx={{ color: '#0202ff' }}>
                          Relationship Between Schedules L, M‑1, and M‑2
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filing" sx={{ color: '#0202ff' }}>
                          Filing Deadlines
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Schedule L Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What Is Schedule L (Form 1120‑S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule L serves as the corporation’s balance sheet per its
                  accounting books, not simply the tax return data. The reported
                  figures must match the corporation’s official financial
                  statements—showing real-world values for assets, liabilities,
                  and equity.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The IRS examines Schedule L to assess:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Whether changes in retained earnings reconcile with income
                    reported on{' '}
                    <Link
                      href="/business-tax/efile-irs-form-1120-s/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 1120‑S.
                    </Link>{' '}
                  </li>
                  <li>
                    Whether deductions, credits, and reporting across parts of
                    the return appear consistent.{' '}
                  </li>
                  <li>
                    Whether shareholder equity aligns with distributions or
                    capital contributions reported elsewhere.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  This balance sheet presentation provides the foundation for
                  reconciling accounting income to taxable income, a critical
                  step in ensuring that Schedule M‑1 and M‑2 are accurate.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key Components of Schedule L
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule L is divided into three main categories: Assets,
                  Liabilities, and Shareholders’ Equity. These categories
                  represent the fundamental structure of your corporation’s
                  balance sheet.{' '}
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  1. Assets
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Assets on Schedule L are reported at both the beginning of the
                  year (BOY) and end of the year (EOY). They include:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Current assets:</span>{' '}
                    cash, accounts receivable, inventories, and short‑term
                    investments.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Fixed assets:</span>{' '}
                    tangible property such as buildings, equipment, furniture,
                    and accumulated depreciation.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>Intangible assets:</span>{' '}
                    goodwill, patents, trademarks, and digital assets (like
                    cryptocurrencies).{' '}
                  </li>
                  <li>
                    {' '}
                    <span style={{ fontWeight: 600 }}> Other assets:</span>{' '}
                    prepaid expenses, deferred charges, and long-term
                    receivables.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Proper valuation and classification ensure accuracy and IRS
                  consistency. For depreciable and amortizable property, the
                  basis and accumulated depreciation must be updated from
                  prior-year returns.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  2. Liabilities
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Liabilities represent what the corporation owes. These are
                  categorized as:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Current liabilities:
                    </span>{' '}
                    accounts payable, short‑term loans, credit lines, and
                    accrued expenses.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Long-term liabilities:
                    </span>{' '}
                    mortgages, bonds, or notes payable that extend beyond one
                    year.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Shareholder loans:</span>{' '}
                    advances or debts between shareholders and the corporation,
                    which must be reported accurately to avoid reclassification
                    as dividends or capital entries.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Clear separation between current and long-term obligations
                  ensures transparency about the corporation’s liquidity and
                  solvency.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  3. Shareholders’ Equity
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  This section reflects the residual value held by shareholders
                  after subtracting liabilities from assets. It includes:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>Common stock and additional paid-in capital</li>
                  <li>
                    Retained earnings and accumulated adjustments account
                    (AAA){' '}
                  </li>
                  <li>
                    Other equity accounts like previously taxed income or
                    accumulated earnings and profits (E&P) from prior
                    C‑corporation years{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Changes in equity from the beginning to the end of the year
                  should align with income reported and distributions made.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must Complete Schedule L?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Most S corporations are required to complete Schedule L;
                  however, small corporations may be exempt under the following
                  criteria:
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  A corporation does not need to complete Schedule L (and
                  Schedule M‑1) if both of these are true:
                </Typography>
                <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Total receipts for the tax year were less than $250,000,
                    and{' '}
                  </li>
                  <li>
                    Total assets at the end of the tax year were less than
                    $250,000.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  These exemptions are addressed in Schedule B, Line 11 of Form
                  1120‑S. If a corporation does not meet both thresholds, it
                  must complete Schedule L and reconcile results with other
                  schedules.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="relation"
                >
                  Relationship Between Schedules L, M‑1, and M‑2
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedules L, M‑1, and M‑2 are closely linked:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Schedule L shows beginning and ending balances for assets,
                    liabilities, and equity.
                  </li>
                  <li>
                    Schedule M‑1 reconciles book income with taxable income
                    using Schedule L totals.
                  </li>
                  <li>
                    Schedule M‑2 analyzes changes in retained earnings
                    (Accumulated Adjustments Account, Other Adjustments, and
                    E&P).{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  A mismatch among these schedules is a common cause of IRS
                  notices and audit red flags.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="filing"
                >
                  Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule L must be filed together with Form 1120‑S.
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell> Form 1120-S</TableCell>
                          <TableCell>March 16, 2026 </TableCell>
                          <TableCell>
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert severity="warning" icon={false} sx={{ mb: 4 }}>
                  <b>Note:</b> The 2025 deadline shifts to March 16 because
                  March 15 falls on a weekend. A timely filed Form 7004 grants a
                  6‑month extension until September 15, 2026.
                </Alert>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Common Mistake
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Consequence
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Correction Tip
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Mismatched beginning and ending balances
                          </TableCell>
                          <TableCell>IRS inquiry or rejected filing </TableCell>
                          <TableCell>
                            Always start with prior‑year ending balances.{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Omitted depreciation or amortization
                          </TableCell>
                          <TableCell>Overstated asset values</TableCell>
                          <TableCell>
                            Reconcile with depreciation schedules (
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f4562.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 4562
                            </Link>
                            ).
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Incorrect classification of shareholder loans
                          </TableCell>
                          <TableCell>
                            Possible reclassification as dividends{' '}
                          </TableCell>
                          <TableCell>
                            Maintain loan agreements and payment records.{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Misalignment with Schedule M‑1 or M‑2
                          </TableCell>
                          <TableCell>
                            Audit risk or IRS mismatch notice
                          </TableCell>
                          <TableCell>
                            Prepare Schedule L prior to M‑1 and M‑2.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Schedule L Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Maintain accurate bookkeeping and year‑end reconciliation
                    throughout the accounting year.
                  </li>
                  <li>
                    Record all accounting adjustments before preparing Schedule
                    L.
                  </li>
                  <li>
                    Ensure totals reconcile with income statements, retained
                    earnings, and shareholder basis.{' '}
                  </li>

                  <li>
                    Use accounting software or e‑filing solutions like{' '}
                    <Link
                      href="/business-tax/efile-irs-form-1120-s/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      TaxZerone
                    </Link>{' '}
                    to automatically populate Schedule L with your bookkeeping
                    data.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is Schedule L used for?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule L reports the S corporation’s assets, liabilities,
                  and shareholder equity as reflected on the company’s books.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Who must file Schedule L?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  All S corporations unless they have receipts and assets below
                  the $250,000 threshold.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. What if my Schedule L does not balance?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  Review retained earnings, distributions, or prior‑year
                  adjustments—imbalances often signal data entry or
                  reconciliation errors.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. When must Schedule L be filed?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It is filed with Form 1120‑S by the corporate tax deadline
                  (March 15 or March 17 if on a weekend), with extensions
                  available via Form 7004.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              File Your Form 1120‑S Including Schedule L with TaxZerone
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure your S corporation’s balance sheet per books is complete,
              accurate, and fully IRS‑compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sschl`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120sSchL;
